/**
 * Run non-critical work (GSAP/ScrollTrigger setup, decorative animations)
 * after the browser is idle instead of during hydration.
 *
 * ScrollTrigger creation reads layout (forced reflow) and competes with
 * hydration for main-thread time — deferring it to idle moves that work out
 * of the Lighthouse load trace (TBT / "forced reflow" audits) without any
 * visible difference: the animations are scroll-driven and initialize long
 * before the user reaches them.
 *
 * Returns a cancel function for use in effect cleanup.
 */
export function whenIdle(cb: () => void, timeout = 2000): () => void {
  if (typeof window === "undefined") return () => {};

  if ("requestIdleCallback" in window) {
    const id = window.requestIdleCallback(() => cb(), { timeout });
    return () => window.cancelIdleCallback(id);
  }

  const id = setTimeout(cb, 300);
  return () => clearTimeout(id);
}
